/**
 * iOS WebKit (Safari, Chrome, Firefox, and the Capacitor WebView on iPhone/iPad).
 * All iOS browsers share WebKit, so Firestore WebChannel and IndexedDB quirks apply.
 */

export type IosWebKitHints = {
  userAgent?: string;
  platform?: string;
  maxTouchPoints?: number;
};

function readNavigator(): IosWebKitHints {
  if (typeof navigator === 'undefined') return {};
  return {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    maxTouchPoints: navigator.maxTouchPoints,
  };
}

/** True on iPhone/iPad/iPod, including iPadOS that reports itself as Macintosh. */
export function isIosWebKit(hints?: IosWebKitHints): boolean {
  const nav = hints ?? readNavigator();
  const ua = nav.userAgent ?? '';
  if (/iP(hone|ad|od)/i.test(ua)) return true;
  // iPadOS 13+ desktop UA: Macintosh + touch.
  return nav.platform === 'MacIntel' && (nav.maxTouchPoints ?? 0) > 1;
}
